import { roles } from '@nxsys/store/constants';
import PayslipDetail from '../../../modules/payslip/detail/PayslipDetail';
import PayslipListing from '../../../modules/payslip/listing/PayslipListing';

export const payslipConfig = [
  {
    permittedRole: [roles.employee],
    path: '/payslip',
    element: <PayslipListing />,
  },
  {
    permittedRole: [roles.employee],
    path: '/payslips/:id',
    element: <PayslipDetail />,
  },
];
